export function detectAndSetTimeZone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  // Set cookie that expires in 1 year
  document.cookie = `timezone=${timezone};path=/;max-age=31536000`
}

// Auto-initialize on page load
document.addEventListener("turbo:load", detectAndSetTimeZone) 